import { DetailsVariants } from 'pages/terms-and-policies/header/DetailsContainer'
import React from 'react'

type DetailsFieldValueProps = {
  value: string
  variant: DetailsVariants
}

const DetailsFieldValue = ({ variant, value }: DetailsFieldValueProps) => {
  return (
    <p
      className={`${
        variant === DetailsVariants.Dark ? 'text-[#25395C]' : 'text-[#f4f4f4]'
      } font-normal text-xs md:text-base leading-tight`}
    >
      {value}
    </p>
  )
}

export default DetailsFieldValue
